// extracted by mini-css-extract-plugin
var _1 = "EmailAttachedTag-moduleEmailAttachedTag__Jw_dG Tag-moduleTag__FLr9H";
export { _1 as "EmailAttachedTag" }
